import React from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center"
          // py: 3
        }}
      >
        <Box
          component="img"
          src="/img/404.png"
          alt="404 Page Not Found"
          sx={{
            width: "100%",
            maxWidth: "500px",
            height: "auto"
            // mb: 4
          }}
        />
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Page Not Found
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          paragraph
          // sx={{ mb: 4 }}
        >
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/")}
          sx={{
            background: "#2B333A",
            color: "white",
            px: 4,
            py: 1.5,
            borderRadius: "8px",
            textTransform: "none",
            fontSize: "1rem",
            "&:hover": {
              background: "#1a1f23"
            }
          }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default PageNotFound;
